import React from 'react'
import PropTypes from 'prop-types'

import states from '../util/states'

const StateComparisonChart = ({ data }) => {
  const minMin = data[Object.keys(data).sort(
    (a, b) => data[a].min - data[b].min,
  )[0]].min
  const maxMax = data[Object.keys(data).sort(
    (a, b) => data[b].max - data[a].max,
  )[0]].max
  const span = maxMax - minMin
  const averageLeft = 100 * ((0 - minMin) / span)
  const rows = Object.keys(data).reduce((currentRows, key, index) => {
    const stateList = Object.keys(data[key].states).filter(state => state)
    const bars = stateList.map((state, stateIndex) => {
      const value = data[key].states[state]
      const width = 100 * (Math.abs(value) / span)
      const left = (value > 0) ? averageLeft : averageLeft - width
      const areaWidth = (value > 0) ? 100 - averageLeft : averageLeft
      const areaLeft = (value > 0) ? averageLeft : 0
      const stateBar = (
        <div
          className={`cmwf--state-comparison-chart--bar ${state}`}
          style={{
            // backgroundColor: stateIndex === 0 ? '#4ABDBC' : '#F47920',
            left: `${left}%`,
            width: `${width}%`,
          }}
        >
          <div className="cmwf--state-comparison-chart--state-name">{states[state]}</div>
        </div>
      )
      const stateBarArea = (
        <div
          className={`cmwf--state-comparison-chart--bar-area`}
          style={{
            left: `${areaLeft}%`,
            width: `${areaWidth}%`,
          }}
        />
      )
      if (stateIndex === 0) {
        return (
          <div
            className={`cmwf--state-comparison-chart--bar-wrapper cmwf--state-comparison-chart--primary ${ value > 0 ? "improved" : "worsened"}`}
            key={stateIndex}
          >
            {stateBar}
            {stateBarArea}
          </div>
        )
      }
      return (
        <div
          className={`cmwf--state-comparison-chart--bar-wrapper cmwf--state-comparison-chart--secondary ${ value > 0 ? "improved" : "worsened"}`}
          key={stateIndex}
        >
          {stateBar}
          {stateBarArea}
        </div>
      )
    })
    return [
      ...currentRows,
      (
        <div className="cmwf--state-comparison-chart--row" key={key}>
          <h3 className="cmwf--state-comparison-chart--label">{key}</h3>
          <div className="cmwf--state-comparison-chart--bars">{bars}</div>
        </div>
      )
    ]
  }, [])
  return (
    <div className="cmwf--state-comparison-chart">
      {rows}
      <div className="cmwf--state-comparison-chart--footer">
        <div className="cmwf--state-comparison-chart--national-average-label">
          <span className="average"
            style={{
              left: `${averageLeft}%`
            }}
            >
            U.S. Average
          </span>
          <span className="below">Below</span>
          <span className="above">Above</span>
        </div>
      </div>
      <div className="cmwf--state-comparison-chart--national-average-line">
        <div style={{
          left: `${averageLeft}%`
        }} />
      </div>
    </div>
  )
}

StateComparisonChart.propTypes = {
  data: PropTypes.objectOf(PropTypes.object).isRequired,
}

export default StateComparisonChart



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/state-comparison-chart.jsx